import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

class RouteNavLink extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <NavLink
        className={this.props.className}
        exact
        onMouseDown={this.props.onMouseDown}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        to={this.props.href}
      >
        {this.props.children}
      </NavLink>
    );
  }
}

RouteNavLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

RouteNavLink.defaultProps = {
  onMouseDown: () => true,
  onMouseEnter: () => true,
  onMouseLeave: () => true,
};

export default RouteNavLink;
